<template>
    <div>
      <div v-if="showicd10modal">
        <!--Illness view popup starts-->
        <transition name="modal">
          <div class="modal-mask">
              <div class="modal-wrapper">
                  <div class="modal-container modal-width500">                     

                      <div class="modal-body p-0">
                        <div class="pb-3 pr-3 pl-3">
                          <div class="col-md-12 px-0">

                         
                        <div class="close-sec-hold" style="right: -15px; top: -15px;">
                           <button type="button" data-dismiss="modal" @click="$emit('cancelAction')" class="close d-close">
                            <i class="material-icons">close</i>
                          </button>
                        </div>                        
                         <h5 class="text-center mt-3 mb-3 m-0">ICD10</h5>
                         
                          <slot name="body">
                            <!-- {{viewillnessdata}} -->
                            <div v-if="viewillnessdata && viewillnessdata.length>0">
                              <div class="row container-list" v-for="item in viewillnessdata">
                                <div class="col-md-12 immuni-dl50">
                                  <dl>
                                    <dt>{{ $t('SelectedCodes') }}</dt>
                                    <dd>: <span v-for="data,index in item.selected_code"> <span
                                          v-if="data.code">{{data.code}}</span>
                                        <span v-if="index < data.code.length>0">, </span>
                                      </span>
                                    </dd>
                                  </dl>
                                  <dl>
                                    <dt>{{ $t('Problems') }}</dt>
                                    <dd>: <span v-for="data,index in item.selected_code"><span
                                          v-if="data.name">{{data.name}}</span>
                                        <span v-if="index < data.name.length>0">, </span>
                                      </span>
                                    </dd>
                                  </dl>
                                  <!-- <dl v-if="item.starting_date">
                                    <dt>Start date</dt>
                                    <dd>: {{item.starting_date}}  </dd>
                                  </dl>

                                  <dl v-if="item.ending_date">
                                    <dt>End date</dt>
                                    <dd>: {{item.ending_date}} </dd>
                                  </dl> -->

                                  <!-- <dl v-if="viewillnessdata.occurences">
                                    <dt>Occurences</dt>
                                    <dd>: {{viewillnessdata.occurences}} </dd>
                                  </dl> -->
                                </div>

                                <!-- <div class="col-md-1"></div> -->

                                <div class="col-md-12 sec-div-line immuni-dl50">
                                  <dl v-if="item.starting_date">
                                    <dt>{{ $t('Startdate') }}</dt>
                                    <dd>: {{item.starting_date}} </dd>
                                  </dl>

                                  <dl v-if="item.ending_date">
                                    <dt>{{ $t('Enddate') }}</dt>
                                    <dd>: {{item.ending_date}} </dd>
                                  </dl>

                                  <dl v-if="item.occurences">
                                    <dt>{{ $t('Occurrences') }}</dt>
                                    <dd>: {{item.occurences}} </dd>
                                  </dl>
                                  <dl v-else>
                                    <dt>{{ $t('Occurrences') }}</dt>
                                    <dd>: N/A </dd>
                                  </dl>

                                  <!-- <dl>
                                    <dt>Schedule</dt>
                                    <dd><span v-for="item in this.viewImmunizationPopupData[0].schedule"  class="d-block">: {{item.schedule_due_date}}</span></dd>
                                    </dl>
                                  -->
                                  <!-- <dl>
                                    <dt>Dosage</dt>
                                    <dd><span v-for="item in this.viewImmunizationPopupData[0].schedule" class="d-block">: {{item.dosage}}</span></dd>
                                    </dl> -->
                                                  <!-- <div class="row w-100">
                                    <div class="col-md-12 pr-0 mt-2">
                                    <table style="border:0px solid transparent;" class="immu-view-flow">                              
                                    <tbody style="border:0px solid transparent;">
                                    <tr >
                                    <td style="vertical-align:top;" >
                                    <table cellspacing="0" cellpadding="0">
                                    <tbody style="border:0px solid transparent;">
                                    <tr >	
                                    <td style="width:15px; height:15px;"><img src="@/static/images/blue-dot.png"></td>
                                    <td style="width:50px; height:15px;"><img src="@/static/images/frequency-track.gif"></td>
                                    <td></td>
                                    </tr>
                                    <tr >	
                                    <td colspan="2"><span style="color:#212529; font-family: 'Poppins', sans-serif !important; font-size:14px; line-height:180%; font-weight:400;">{{item.schedule_due_date}}<br>{{item.dosage}}<br><span data-toggle="tooltip" title="Completed date">{{item.scheduled_comp_date}}</span></span></td>

                                    </tr>
                                    </tbody>
                                    </table>
                                    </td>
                                    </tr>
                                    </tbody>
                                    </table>
                                    </div>
                                    </div> -->

                                </div>
                              </div>

                              <div class="row w-100" v-if="viewillnessdata.notes_item">
                                <div class="col-md-12 mt-3">
                                  <dl class="immuni-dldt100">
                                    <dt>Comments</dt>
                                    <dd>: {{viewillnessdata.notes_item}} </dd>
                                  </dl>
                                </div>
                              </div>
                            </div>
                            <div v-else>
                              No ICD10 data has been entered yet
                            </div>
                          </slot>
                           </div>
                        </div>
                      </div>

                      <div class="modal-footer">
                        <slot name="footer">
                        </slot>
                      </div>
                  </div>
              </div>
          </div>
        </transition>
        <!--Illness view popup ends-->
      </div>
    </div>
</template>

<script>
export default {
  props:["showicd10modal","viewillnessdata"],
  data(){
    return {
      //viewillnessdata:null,
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
 
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}



/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-container.modal-width500{max-width:750px; width:750px; padding: 10px;}
.modal-container.modal-width500 .modal-header{border-bottom:1px solid transparent !important; padding-bottom: 0px !important;}
.modal-container.modal-width500 .modal-footer{border-top:1px solid transparent !important;}
.modal-container.modal-width500 .modal-header{min-height: 10px !important;}
.modal-container.modal-width500 .modal-body{margin: 0px !important;}
.sec-div-line{    border-bottom: 1px solid #eee;    margin-bottom: 20px;    padding-bottom: 20px;}
.container-list:last-child .sec-div-line{border:0; margin-bottom: 0; padding-bottom: 0;}
</style>